import { composeSelector } from "seneca-common/utils/selectors/compose-selectors";

import { getLocationsStateSlice } from "./";
import { getMetaSlice } from "./state";
import * as meta from "./state/meta";

type State = any;

function getMetaState(state: State) {
  return getMetaSlice(getLocationsStateSlice(state));
}

// fetch
export const locationsAreFetching: (arg0: State) => boolean = composeSelector(
  getMetaState,
  meta.locationsAreFetching
);

export const locationsFetchSucceeded: (arg0: State) => boolean =
  composeSelector(getMetaState, meta.locationsFetchSucceeded);

export const locationsFetchErrored: (arg0: State) => boolean = composeSelector(
  getMetaState,
  meta.locationsFetchErrored
);

export const locationsFetchFinished: (arg0: State) => boolean = composeSelector(
  getMetaState,
  meta.locationsFetchFinished
);

export const locationsNeedFetching: (arg0: State) => boolean = composeSelector(
  getMetaState,
  meta.locationsNeedFetching
);
